import { SyntheticEvent, forwardRef } from "react";
import { BiCalendar } from "react-icons/bi";
import ReactDatePicker, {
  DatePickerProps as ReactDatePickerProps,
} from "react-datepicker";
import { inputTypeStyles } from "@memento/ui/Form/Input";
import { preventDefault } from "src/libs/event-lib";
import { cn } from "src/utils/cn";

type StyledButtonProps = {
  value?: string;
  placeholderText?: string;
  onClick?: (e: SyntheticEvent<Element, Event>) => void;
  className?: string;
};

const StyledButton = forwardRef<HTMLButtonElement, StyledButtonProps>(
  ({ value, placeholderText, className, onClick = () => null }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          inputTypeStyles.text,
          "flex items-center rounded-md border-gray-300 p-2 text-sm focus:border-orange-700 focus:ring-orange-700",
          className
        )}
        onClick={preventDefault(onClick)}
        type="button"
      >
        <>
          <BiCalendar size={20} className="mr-2 inline text-gray-600" />
          {value ?? placeholderText ?? "Select a date"}
        </>
      </button>
    );
  }
);

export type DatePickerProps = ReactDatePickerProps;

export function DatePicker({ ...props }: DatePickerProps) {
  return (
    <ReactDatePicker
      customInput={
        <StyledButton
          placeholderText={props.placeholderText}
          onClick={
            props.onChange as unknown as (
              e: SyntheticEvent<Element, Event>
            ) => void
          }
        />
      }
      {...props}
    />
  );
}
